import Skill from 'actions/skill';

export default Skill.createReducer();